import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface SnsLinkProps {
    className?: string;
}

export default function SnsLink({ className }: SnsLinkProps) {
    return (
        <ul className={twMerge("flex items-center gap-[40px]", className)}>
            <li>
                <Link
                    to="https://www.instagram.com/gxg_gameculture/"
                    target="_blank"
                    className="block size-[28px] font-0 -indent-[9999px] bg-icInsta bg-cover"
                >
                    인스타그램
                </Link>
            </li>
            <li>
                <Link
                    to="https://www.facebook.com/people/GXG_gameculture/100094975943247/"
                    target="_blank"
                    className="block size-[28px] font-0 -indent-[9999px] bg-icFacebook bg-cover"
                >
                    페이스북
                </Link>
            </li>
            <li>
                <Link
                    to="https://www.youtube.com/@GXG_gameculture"
                    target="_blank"
                    className="block size-[28px] font-0 -indent-[9999px] bg-icYoutube bg-cover"
                >
                    유튜브
                </Link>
            </li>
            <li>
                <Link to={`/`} className="block size-[28px] font-0 -indent-[9999px] bg-icHome bg-cover">
                    홈
                </Link>
            </li>
        </ul>
    );
}
